import React from 'react';
import { AlertBar } from './components/AlertBar';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { Transformation } from './components/Transformation';
import { Benefits } from './components/Benefits';
import { ProductBreakdown } from './components/ProductBreakdown';
import { ProductPreview } from './components/ProductPreview';
import { ValueStack } from './components/ValueStack';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyBuyBar } from './components/StickyBuyBar';
export function App() {
  return <div className="w-full bg-cream font-sans text-[#2F3A2E]" data-id="element-0" data-mp="28u5x8kp911bs">
      <AlertBar data-id="element-1" data-mp="28sl5t3y8dyi5" />
      <main data-id="element-2" data-mp="28s2ynca15zvg">
        <Hero data-id="element-3" data-mp="23vkw8j26adma" />
        <ProblemSection data-id="element-4" data-mp="23vul23bheeqe" />
        <Transformation data-id="element-5" data-mp="23ujlygszdv5m" />
        <Benefits data-id="element-6" data-mp="23t8i6gzjcnei" />
        <ProductBreakdown data-id="element-7" data-mp="3ijxqiu0iq6lh" />
        <ProductPreview data-id="element-8" data-mp="3ikr0s4yore8d" />
        <ValueStack data-id="element-9" data-mp="3ij61k21ff746" />
        <Offer data-id="element-10" data-mp="3ihv2gfixenje" />
        <Testimonials data-id="element-11" data-mp="3mlja0y7k5j4n" />
        <FAQ data-id="element-12" data-mp="3ml12v6jcxkhy" />
        <FinalCTA data-id="element-13" data-mp="3mkhlbqxmcy4g" />
      </main>
      <Footer data-id="element-14" data-mp="3mjq2zht18ww4" />
      <StickyBuyBar data-id="element-15" data-mp="3mj6ipufwtwex" />
    </div>;
}